import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayColumnDialogComponent } from './display-column-dialog.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    DisplayColumnDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports:[
    DisplayColumnDialogComponent
  ]
})
export class DisplayColumnDialogModule { }
